import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function StatsNumber({
  value = 0, title, format = '0', textColor = '',
}) {
  return (
    <div className="stats-element">
      <div className={`stats-element__value ${textColor}`}>{numeral(value).format(format)}</div>
      <div className="stats-element__title">{title}</div>
    </div>
  )
}

StatsNumber.propTypes = {
  value: PropTypes.number,
  title: PropTypes.string.isRequired,
  format: PropTypes.string,
  textColor: PropTypes.string,
}

export default StatsNumber
